import { ref } from 'vue'
import { defineStore } from 'pinia'

export type NavContext = 'organizer' | 'participant'

export const useNavContextStore = defineStore('navContext', () => {
    const context = ref<NavContext>('participant')

    function setContext(ctx: NavContext) {
        context.value = ctx
    }

    return { context, setContext }
})
